var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentPage)?_c('div',_vm._l((_vm.pages),function(page,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentPage === index + 1),expression:"currentPage === index + 1"}],key:index,staticClass:"multistep-wizard-form-step-page",attrs:{"id":'page'+(index+1)}},[_vm._t('page-'+(index+1))],2)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }